export const getDefaultState = () => ({
  subscriptions: [],
});
export const state = getDefaultState();
